<template>
    <transition name="application-tour__fade">
        <div class="c-application-tour" v-if="!close && init" v-on:click="toggleTutorial">
            <span class="c-application-tour__close" v-on:click.stop="toggleTutorial"></span>
            <div class="c-application-tour__container">
                <div class="c-application-tour__content">
                    <transition name="application-tour__fade-content" v-on:after-leave="afterLeave" v-on:before-enter="beforeEnter">
                        <div class="c-application-tour__content__welcome" v-if="!start && show === true" >
                            <h2 class="c-rkw-content__header c-rkw-content__header--application-tour">Herzlich willkommen im <br>RKW-Digitalisierungs-Cockpit</h2>
                            <p class="c-rkw-content__body c-rkw-content__body--application-tour" v-html="tutorial.intro"></p>
                            <span class="c-rkw-content__button c-rkw-content__button--skip" v-on:click.stop="toggleTutorial">Überspringen</span>
                            <span class="c-rkw-content__button c-rkw-content__button--tutorial c-rkw-content__button--invert" v-on:click.stop="tutorial.start = true"></span>
                        </div>
                        <div class="c-application-tour__content__tutorial" v-if="start && show === tutorial.currentStep">
                            <h2 class="c-rkw-content__header c-rkw-content__header--application-tour">Schritt {{ tutorial.currentStep }} von {{ tutorial.maxSteps }}</h2>
                            <div class="c-application-tour__information" v-if="current !== null">
                                <video v-if="current.type === 'mp4'" autoplay loop class="c-application-tour__video" id="videoPlayer">
                                    <source :src="settings.pageUrl + current.url" type="video/mp4">
                                </video>
                                <img :src="settings.pageUrl + current.url" v-if="current.type !== 'mp4'" class="c-application-tour__image"/>
                                <p class="c-rkw-content__body c-rkw-content__body--application-tour-description">{{current.description}}</p>
                            </div>
                            <div class="c-application-tour__tutorial-control">
                                <span class="c-rkw-content__button c-rkw-content__button--tutorial-prev" v-if="prev" v-on:click.stop="prevStep"><span>Zurück</span></span>
                                <span class="c-rkw-content__button c-rkw-content__button--skip" v-if="next" v-on:click.stop="toggleTutorial">Überspringen</span>
                                <span class="c-rkw-content__button c-rkw-content__button--lets-go c-rkw-content__button--invert" v-if="!next" v-on:click.stop="toggleTutorial"></span>
                                <span class="c-rkw-content__button c-rkw-content__button--tutorial-next c-rkw-content__button--invert" v-if="next" v-on:click.stop="nextStep"></span>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import mixins from "../mixins"

    export default {
        data() {
            return {
                tutorial: {
                    init: false,
                    data: null,
                    start: false,
                    currentStep: 1,
                    maxSteps: null,
                    intro: ''
                },
                current: null,
                video: null,
                show: true

            }
        },
        mixins: [mixins],
        computed: {
            settings () {
                return this.$store.state.settings
            },
            init () {
                return this.tutorial.init
            },
            close () {
                return this.$store.state.runtime.tutorial
            },
            start () {
                return this.tutorial.start
            },
            prev () {
                return this.tutorial.currentStep > 1
            },
            next () {
                return this.tutorial.currentStep < this.tutorial.maxSteps
            },
            data () {
                return this.current !== null
            }
        },
        watch: {
            'start' () {
                this.getCurrentData()
            },
            'tutorial.currentStep' () {
                this.getCurrentData()
            },
            '$store.state.runtime.tutorial' () {
                this.tutorial = {
                    init: false,
                    data: null,
                    start: false,
                    currentStep: 1,
                    maxSteps: null,
                    intro: ''
                }
                this.current = null
                this.show = true
                this.initialize()
            },
            'show' () {

            }
        },
        mounted () {
            this.initialize()

            let storage = window.localStorage
            let tutorial = storage.getItem('rkw-digikit_tutorial');

            if (tutorial === null) {
                this.$store.commit('toggleTutorial')
                storage.setItem('rkw-digikit_tutorial', true)
            }
        },
        methods: {
            initialize () {
                this.tutorial.data = (this.isMobile()) ? this.$store.state.data['tutorial']['dataMobile'] : this.$store.state.data['tutorial']['data']
                this.tutorial.intro = (this.isMobile()) ? this.$store.state.data['tutorial']['introMobile'] : this.$store.state.data['tutorial']['intro']

                if (this.tutorial.data !== undefined && this.tutorial.data.length > 0) {
                    this.tutorial.init = true
                    this.tutorial.maxSteps = this.tutorial.data.length
                }
            },
            getCurrentData () {
                this.current = this.tutorial.data[this.tutorial.currentStep - 1]
                if (this.current.type === 'mp4') {
                    let player = this.$root.$el.querySelector('#videoPlayer')
                    if (player !== null) {
                        player.load()
                    }
                }
            },
            nextStep () {
                this.show = 0
                window.setTimeout(() => {
                    this.tutorial.currentStep += 1
                }, 500)
            },
            prevStep () {
                this.show = 0
                window.setTimeout(() => {
                    this.tutorial.currentStep -= 1
                }, 500)
            },
            beforeEnter () {

            },
            afterLeave() {
                this.show = this.tutorial.currentStep
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ApplicationTour.vue?aa62b7f6